/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, ReactElement, useCallback, useState } from 'react';
import {
  BackErrorImgPngType,
  BackErrorType,
  ErrorProviderType,
  ErrorType,
  WarningType,
} from '../types/Types';
import { BackMappings } from '../utils/BackMappings';
import { SessionChecker } from '../utils/SessionChecker';
import { useAppStore } from './AppContext';

export const defaultErrorValue = {};

export const APIErrorContext = React.createContext<ErrorProviderType>(
  defaultErrorValue as ErrorProviderType,
);

type Props = {
  children: ReactElement;
};

export const APIErrorProvider: FC<Props> = ({ children }) => {
  const [error, setError] = useState<ErrorType>({} as ErrorType);
  const [errorBack, setErrorBack] = useState<BackErrorType>(
    {} as BackErrorType,
  );
  const [errorBackImgPng, setErrorBackImgPng] = useState<BackErrorImgPngType>(
    {} as BackErrorImgPngType,
  );
  const [warning, setWarning] = useState<WarningType>({} as WarningType);
  const [oro, setOro] = useState<boolean>(false as boolean);
  const { lang } = useAppStore();

  const removeError = useCallback(() => {
    setError({} as ErrorType);
    setErrorBack({} as BackErrorType);
    setErrorBackImgPng({} as BackErrorImgPngType);
    setWarning({} as WarningType);
  }, []);

  const addError = useCallback(
    (message: string, status: string, style = false) => {
      setError({ message, status, style });
      setOro(false);
    },
    [],
  );

  const addErrorBack = useCallback(
    (err: BackErrorType) => {
      const errorCode = err.errorCode as number;
      if (
        errorCode &&
        (errorCode === BackMappings.GO_TO_LOGIN || errorCode === 1)
      ) {
        SessionChecker.closeSessionAndGoToLogin(null, lang);
      } else if (errorCode && errorCode === BackMappings.GO_TO_RELOGIN) {
        SessionChecker.closeSessionAndGoToReLogin(null, lang);
      } else {
        setErrorBack(err);
        setOro(false);
      }
    },
    [lang],
  );

  const addErrorBackImgPng = useCallback(
    (err: BackErrorImgPngType) => {
      const errorCode = err.errorCode as number;
      if (
        errorCode &&
        (errorCode === BackMappings.GO_TO_LOGIN || errorCode === 1)
      ) {
        SessionChecker.closeSessionAndGoToLogin(null, lang);
      } else if (errorCode && errorCode === BackMappings.GO_TO_RELOGIN) {
        SessionChecker.closeSessionAndGoToReLogin(null, lang);
      } else {
        setErrorBackImgPng(err);
        setOro(false);
      }
    },
    [lang],
  );

  const addWarning = useCallback((message: string) => {
    setWarning({ message });
  }, []);

  const addOro = useCallback((isOro: boolean) => setOro(isOro), []);

  const contextValue = {
    error,
    errorBack,
    errorBackImgPng,
    warning,
    oro,
    addError,
    addErrorBack,
    addErrorBackImgPng,
    addWarning,
    removeError,
    addOro,
  } as ErrorProviderType;

  return (
    <APIErrorContext.Provider value={contextValue}>
      {children}
    </APIErrorContext.Provider>
  );
};
